module.exports = __webpack_public_path__ + "assets/1bc31a33d808c35a5db78b9887ff0cc7.mp3";